import * as TypeUtil from './TypeUtil'

export const DATA = 'data'
export const INDEXES = 'indexes'
export const TEMPLATES = 'templates'
export const CONTENTS = 'contents'
export const QUEUES = 'queues'
export const IMAGES = 'images'
export const VIDEOS = 'videos'
export const FILES = 'files'

export const _ = '_'
export const Q_ = 'q_'
export const ID = '_id'
export const TYPE = '_type'
export const SLUG = '_slug'
export const NAME = 'name'
export const CREATED = '_created'
export const UPDATED = '_updated'
export const DOT_JSON = '.json'

export function fetchText(filePath, cb, cbe) {
  if (TypeUtil.isNonEmptyString(filePath)) {
    fetch(filePath).then(response=>{
      if (response.ok) return response.text()
      throw new Error('Network response was not ok.')
    }).then(text=>{
      if (TypeUtil.isString(text)) {
        if (typeof(cb)==='function') {
          cb(text)
        }
      } else {
        if(typeof(cbe)==='function') {
          cbe({
            message: `Not a text or undefined, ${text}`
          })
        }
      }
    }).catch(e=>{
      if(typeof(cbe)==='function') {
        cbe(e)
      }
    })
  }
}

export function fetchObject(filePath, cb, cbe) {
  if (TypeUtil.isNonEmptyString(filePath)) {
    fetch(filePath).then(response=>{
      if(response.ok) {
        return response.json()
      }
      throw new Error('Network response was not ok.')
    }).then(data=>{
      if (TypeUtil.isObject(data)) {
        if(typeof(cb)==='function') {
          cb(data)
        }
      } else {
        if(typeof(cbe)==='function') {
          cbe({
            message: `Not an object or null, ${data}`
          })
        }
      }
    }).catch(e=>{
      if(typeof(cbe)==='function') {
        cbe(e)
      }
    })
  }
}

export function fetchArray(filePath, cb, cbe) {
  fetchObject(filePath, (data)=>{
    if (Array.isArray(data)) {
      if(typeof(cb)==='function') {
        cb(data)
      }
    }
  }, cbe)
}
